export default "__VITE_ASSET__CAiha623__"